var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "650" },
          on: {
            "click:outside": function($event) {
              return _vm.closePaymentCreate()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "mr-2",
                          attrs: {
                            color: "primary",
                            rounded: "",
                            depressed: ""
                          }
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", [_vm._v(" mdi-plus-circle ")]),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.$t("payment.btn.bank")) + " ")
                      ])
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "pt-3" },
                [
                  _c(
                    "div",
                    { staticClass: "close-popup" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.closePaymentCreate()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v(" mdi-close ")])],
                        1
                      )
                    ],
                    1
                  ),
                  _c("title-label", {
                    attrs: { label: _vm.$t("payment.label.addBank") }
                  }),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass: "mt-3",
                      attrs: { readonly: _vm.loading, "lazy-validation": "" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.submit()
                        }
                      },
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [_c("payment-form", { attrs: { form: _vm.form } })],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-end mt-3" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", text: "" },
                          on: {
                            click: function($event) {
                              return _vm.closePaymentCreate()
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("payment.btn.cancel")) + " "
                          )
                        ]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            rounded: "",
                            depressed: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.submit()
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("payment.btn.confirm")) + " "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }